<template>
    <toolbar-option>
        <template slot="primary">
            <button class="button" @click="showModal('modal-html-custom-attributes')">
                MANAGE
            </button>
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import { SHOW_MODAL } from '@/store/types/mutation-types';

export default {
    name: 'html-custom-attributes',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'HTML Custom Attributes',
            value: '',
            autoSubmit: '',
        };
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}
</style>
